import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function IdsChevronRight(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path id="footprint" d="M24,24H0V0H24V24Z" fill="none"/>
      <path id="chevron-right" d="M9.89,19.03c-.32,.37-.88,.41-1.25,.1-.35-.3-.41-.8-.15-1.17l.06-.07,5.07-5.88-5.07-5.88c-.3-.35-.28-.86,.03-1.18l.07-.06c.35-.3,.86-.28,1.19,.03l.06,.07,5.56,6.45c.26,.31,.28,.75,.05,1.08l-.05,.07-5.56,6.45Z" fillRule="evenodd"/>
    </SvgIcon>
  ); 
}